module.exports = __webpack_public_path__ + "static/media/nasser_elhajjaoui.21314886.png";